import { useEffect, useRef, useState } from 'react';
import { clearAnimationFrameTimeout, setAnimationFrameTimeout, } from '../helpers/setAnimationFrameTimeout';
export function useTransition(state, timeout) {
    // the stage of transition - 'from' | 'enter' | 'leave'
    const [stage, setStage] = useState(state ? 'enter' : 'from');
    // the timer for should mount
    const timer = useRef({});
    const [shouldMount, setShouldMount] = useState(state);
    useEffect(function handleStateChange() {
        clearAnimationFrameTimeout(timer.current);
        // when true - trans from to enter
        // when false - trans enter to leave, unmount after timeout
        if (state) {
            setStage('from');
            setShouldMount(true);
            setAnimationFrameTimeout(() => {
                setStage('enter');
            });
        }
        else {
            setStage('leave');
            timer.current = setAnimationFrameTimeout(() => {
                setShouldMount(false);
            }, timeout);
        }
        return () => {
            clearAnimationFrameTimeout(timer.current);
        };
    }, [state, timeout]);
    return {
        stage,
        shouldMount,
    };
}
